<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
<div class="container" style="width:100%">
          <div class="row" *ngIf="userpet">
            <div class="col-12" *ngFor="let pet of userpet  | paginate: { itemsPerPage: 4, currentPage: p }">
              <div class="card"  style="margin-top:10px">
              <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div class="row">
                  <div class="col">
                      <img src="https://passport.petcart.in/images/petimages/{{pet.image}}">
                  </div>
                  <div class="col">
                    <p>{{pet.pet_name}}</p>
                    <p>{{pet.pet_type}}</p>
                    <p>{{pet.bio}}</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                 <div class="card-header text-center" style="background: #9b7544; color:#fff">
                   Documents
                 </div>
                 <div  *ngIf="document.length> 0">
                  <div class="col-12 text-center">
                    <p><strong> ({{documentCount(pet.id)}}) Documents Found</strong></p>
                 </div>
                 <div class="col-12 text-center" *ngIf="documentCount(pet.id)>0">
                  <p style="color:#9b7544; cursor: pointer" (click)="viewDocument(pet.id)">
                    <strong><u>View All Documents</u></strong></p>
                  </div>
                 </div>
                </div>
              </div>
            </div>
            </div>
          </div>
          <div class="row" *ngIf="userpet && userpet.length>0">
              <div class="col-12 text-right">
                <pagination-controls  (pageChange)="p = $event"></pagination-controls >
              </div>
            </div>
            <div class="row" style="margin-top: 200px" *ngIf="nopet ==1">
              <div class="col-12 text-center">
                <p style="color:red; font-size:20px"><strong> No pet Found</strong></p>
              </div>
            </div>
  </div>
 
  <ng-template #textimage>
      <div class="col-sm-4 col-md-2 col-lg-2 col-xl-2 text-center">
          <img class="avatar1 " src="https://passport.petcart.in/images/petimages/doc.png">
      </div>
      
  </ng-template>